import { isMobile } from "react-device-detect"

// This file handles adjusting common theme values and device adjustments
export const deviceMargin = isMobile ? 1 : 5